import GamesList from '@pages/gamers/games/games';
export default GamesList;
